import { ICellRendererParams } from 'ag-grid-community';
import { EActivityType, IEVMTransaction } from 'src/types';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from 'src/components/ui/tooltip';

export const AssetCellRenderer = (params: ICellRendererParams) => {
  const tx = params.data as IEVMTransaction;
  if (
    tx.type === EActivityType.NATIVE ||
    tx.type === EActivityType.CONTRACT_CALL
  ) {
    return 'ETH';
  }

  return (
    <div className="flex items-center gap-2">
      {tx.tokenMetadata?.logo && (
        <img
          src={tx.tokenMetadata.logo}
          alt={tx.tokenMetadata.display_name}
          className="h-5 w-5 rounded-full"
          onError={(e) => {
            (e.target as HTMLImageElement).style.display = 'none';
          }}
        />
      )}
      <Tooltip>
        <TooltipTrigger asChild>
          <span>{tx.tokenMetadata?.display_name || 'ERC20'}</span>
        </TooltipTrigger>
        <TooltipContent>
          <p>{tx.asset}</p>
        </TooltipContent>
      </Tooltip>
    </div>
  );
};
